<!-- 项目文件 -->
<template>
  <div>
    <Header :Logo="logo" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>
    <div class="w100p  pb40 bgfff">
      <div class="w1260 mauto"> 
        <div class="mt50 mb50">
          <div class="textc mt20 mb20">
             <p class="fs36 c333 disinblock posre">
									<span class="border-bottom1">
											服务内容
									</span>
							</p>
          </div>
          <div class="w100p  mt40 mb20">
            <router-link to="Smallprogram">
              <div class="vertop minh200 w22p disinblock ml18 mr18 box-shadow2 pt32 pb32">
                  <p class=" textc"><img class="w52 h52 showimg" src="../../public/img/img16.png"></p>
                  <p  class="pt32 fs20 c333 textc show h30">驾校招生小程序</p>
                  <p class="pt32 fs14 c999 textc">
                    <span class="textc  fs14 c999 disblock pt5 pb5">爆炸式营销</span>
                    <span class="textc  fs14 c999 disblock pt5 pb5">提升驾校50%生源</span>
                  </p>
              </div>
            </router-link>

            <router-link to="System">
              <div class="vertop minh200 w22p disinblock ml18 mr18 box-shadow2 pt32 pb32">
                <p class=" textc"><img class="w50 h47 showimg" src="../../public/img/img17.png"></p>
                <p class="pt32 fs20 c333 textc show">驾校培训系统</p>
                <p class="pt32 fs14 c999 textc">
                  <span class="textc  fs14 c999 disblock pt5 pb5">提升驾校40%效能</span>
                  <span class="textc  fs14 c999 disblock pt5 pb5">降低驾校30%成本</span>
                </p>
              </div>
            </router-link>
        
            <router-link to="Wemedia">
              <div class="vertop minh200 w22p disinblock ml18 mr18 box-shadow2 pt32 pb32">
                <p class=" textc"><img class="w50 h36 showimg" src="../../public/img/img18.png"></p>
                <p class="pt32 fs20 c333 textc show">自媒体运营</p>
                <p class="pt32 fs14 c999 textc">
                  <span class="textc  fs14 c999 disblock pt5 pb5">打造驾校专属多功能微信服务号</span>
                  <span class="textc  fs14 c999 disblock pt5 pb5">窗口，实现驾校品牌升级内容</span>
                </p>
              </div>
            </router-link>

            <router-link to="Meltmedia">
              <div class="vertop minh200 w22p disinblock ml18 mr18 box-shadow2 pt32 pb32">
                <p class=" textc"><img class="w52 h44 showimg" src="../../public/img/img19.png"></p>
                <p class="pt32 fs20 c333 textc show">融媒体推广</p>
                <p class="pt32 fs14 c999 textc">
                  <span class="textc  fs14 c999 disblock pt5 pb5">流量快速曝光</span>
                  <span class="textc  fs14 c999 disblock pt5 pb5">拓宽驾校招生媒体渠道</span>
                </p>
              </div>
            </router-link>

          </div>
        </div>
        <div class="mt50 mb50">
          <div class="textc mt20 mb20">
             <p class="fs36 c333 disinblock posre">
									<span class="border-bottom1">
											最新案例
									</span>
							</p>
          </div>
          <div class="w100p overflow mt30 mb20">
            <div class="bradius8 mt10 w23p vertop disinblock ml10 mr10 br8 baee cursor" @click="Todetail(item.id)" v-if="item.type==2" v-for="(item,index) in caseList" :key="index">
              <img class="w100p  h180" :src="item.image || 'https://365taoke.oss-cn-hangzhou.aliyuncs.com/card/20200429/img1.png' ">
              <div class="fs16 c333 lh28 pd15" style="min-height: 56px;">
                {{item.title}}
              </div>
            </div>
            
          </div>
        </div> 
        <div class="mt50 mb50">
          <div class="mt20 mb20 textc">
            <span class="border1f8 ml16 mr16 pt14 pb14 fbold pl80 pr80 bradius8">
              <a class=" c1f8 fs18 " target="_blank" href="http://jiaxiao.yixueyijia.com/">登录后台</a>
            </span>
            
            <span  @click="open()" class="bg1f8 cfff fs18 ml16 mr16 pt14 pb14 fbold cursor pl80 pr80 bradius8">申请入驻</span>
            
          </div>
        </div>
      </div>
    </div>

    <div class="posfix bgrg w100p h100p zindex999 pl10 pr10 overflow top0 left0" v-show="mask==1">
      <div class="posab left30p top30p bgfff w30p pt20 pb20 pl40 pr40 bradius8">
        <p class=" fbold fs20 c1f8 textc">申请入驻</p>
        <span @click="choose()" class="disinblock posab top0 right11 fs26 c333 cursor"> × </span>
        <div class="pt20 pb20">
          <p class="posre bradius8 baee h40 alit mt20 mb20">
            <span class="posab pr12 pl12 "><img class="w16 h16" src="../../public/img/css.png"></span>
            <input v-model="School" class="textindent2 baee bradius8 w100p h100p borderno outline" type="text"
              placeholder="请输入驾校...">
          </p>
          <p class="posre bradius8 baee h40 alit mt20 mb20">
            <span class="posab pr12 pl12 "><img class="w10 h14" src="../../public/img/img97.png"></span>
            <input v-model="Name" class="textindent2 baee bradius8 w100p h100p borderno outline" type="text"
              placeholder="请输入姓名...">
          </p>
          <p class="posre bradius8 baee h40 alit mt20 mb20">
            <span class="posab  pr12 pl12 "><img class="w10 h14" src="../../public/img/img98.png"></span>
            <input v-model="Phone" class="textindent2 baee bradius8 w100p h100p borderno outline" type="text"
              placeholder="请输入手机号...">
          </p>
          <p @click="sentApply()" class=" h50 lh50 bradius8 cursor mt20 mb20 cfff bg1f8 textc fbold fs18 ">
            确认提交
          </p>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import $ from "jquery";
    export default {
        data() {
            return {
                color: 3,
                link: 0,
                titleList: 0,
                logo: 'school',
                bgImg: require('../../public/img/img6.png'),
                mask: 0,
                Name: '',
                Phone: '',
                School: '',
                caseList: []
            };
        },
        components: {
            Header,
            Footer
        },
        methods: {
            open() {
                this.mask = 1;
                $('body').css("overflow", "hidden")
            },
            choose() {
                this.mask = 0;
                $('body').css("overflow", "auto")
            },
            sentApply() {
                let that = this;
                if (that.Name == "" || that.School == "" || !(/^1[23456789]\d{9}$/.test(that.Phone))) {
                    alert('请正确输入');
                    return 0;
                } else {
                    $.ajax({
                        type: "POST",
                        url: that.beseSend + "/openapi/drivingin/insterDrivingin.json",
                        dataType: "json",
                        async: false,
                        data: {
                            "name": that.Name,
                            "phone": that.Phone,
                            'belongstoschool': that.School,
                            'channel': 'exejapp'
                        },
                        success: function(data) {
                            alert(data.resultObj.info)
                            that.choose();
                            that.Name = "";
                            that.Phone = "";
                            that.School = "";
                        },
                        error: function(data) {
                            console.log(data);
                        }
                    });
                }

            },
            getNews() {
                let that = this;

                $.ajax({
                    type: "POST",
                    url: "https://www.yixueyijia.com/product/news.json",
                    dataType: "json",
                    async: false,
                    data: {
                        "class_id ": 9,
                    },
                    success: function(data) {
                        that.caseList = data.obj;
                        console.log(data.obj);
                        that.$forceUpdate()
                        that.$store.dispatch('Companynewsment').then(() => {
                            that.$store.state.CompanynewsDetail = that.caseList;
                        });

                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            },
            Todetail(id) {
                let that = this;
                this.$router.push({
                    path: "/AboutNewsdetail",
                    query: {
                        news_id: id,
                    }
                });
            },
        },
        created() {
            this.getNews()
        },
        mounted() {

        },
    }
</script>
<style scoped>
    .bgrg {
        background: rgba(0, 0, 0, 0.5);
    }
</style>